import React from 'react';

import withPageComponents from '../../../page/components/with-page-components';

const Sku = ({ productInitial }) => {
    if (!productInitial) return null;

    const { sku } = productInitial;

    return (
        <div className="sku">
            <span className="skuPrefix">{'Product # '}</span>
            {sku}
        </div>
    );
};

export default withPageComponents(Sku, {
    components: ['productInitial'],
});
